import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "@teamprevent/common/healthSurveillance";

import * as questionIds from "./questionIds";

const medicalTypes = [
    MedicalTypeIds.Audiometry,
    MedicalTypeIds.SafetyCriticalWorker,
    MedicalTypeIds.Offshore,
    MedicalTypeIds.Airside,
    MedicalTypeIds.OtherFitnessToWork
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../consultation";` which is in a data structure suitable for use with custom medicals
 */
export const audiometryQuestions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.AudiometryUnableToCarryOut,
        questionText: "Unable to carry out medical",
        medicalTypes
    },
    {
        id: questionIds.AudiometryUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
        medicalTypes
    },
    {
        id: questionIds.AudiometryMachineSerialNumber,
        questionText: "Serial number of machine",
        medicalTypes
    },
    {
        id: questionIds.AudiometryCalibrationDate,
        questionText: "Calibration date (most recent)",
        medicalTypes
    },
    {
        id: questionIds.AudiometryReasonForAttending,
        questionText: "Reason for attending",
        medicalTypes
    },
    {
        id: questionIds.AudiometryDateOfLastTest,
        questionText: "Date of last test",
        medicalTypes
    },
    {
        id: questionIds.AudiometryGender,
        questionText: "Gender",
        medicalTypes
    },
    {
        id: questionIds.AudiometryAge,
        questionText: "Age",
        medicalTypes
    },
    {
        id: questionIds.AudiometryLeftEarWaxVisible,
        questionText: "Wax visible left ear",
        medicalTypes
    },
    {
        id: questionIds.AudiometryRightEarWaxVisible,
        questionText: "Wax visible right ear",
        medicalTypes
    },
    {
        id: questionIds.AudiometryScarringLeftEar,
        questionText: "Scarring evident left ear",
        medicalTypes
    },
    {
        id: questionIds.AudiometryScarringLeftEarComments,
        questionText: "Comments",
        medicalTypes
    },
    {
        id: questionIds.AudiometryScarringRightEar,
        questionText: "Scarring evident right ear",
        medicalTypes
    },
    {
        id: questionIds.AudiometryScarringRightEarComments,
        questionText: "Comments",
        medicalTypes
    },
    {
        id: questionIds.AudiometryInfectionCongestionLeftEar,
        questionText: "Infection/congestion indicated left ear",
        medicalTypes
    },
    {
        id: questionIds.AudiometryInfectionCongestionLeftEarComments,
        questionText: "Comments",
        medicalTypes
    },
    {
        id: questionIds.AudiometryInfectionCongestionRightEar,
        questionText: "Infection/congestion indicated right ear",
        medicalTypes
    },
    {
        id: questionIds.AudiometryInfectionCongestionRightEarComments,
        questionText: "Comments",
        medicalTypes
    },
    {
        id: questionIds.AudiometryEntIssues,
        questionText: "Current or historical ENT issues for client which may impact on test result or contraindication to testing client today",
        medicalTypes
    },
    {
        id: questionIds.AudiometryLeftEar0_500,
        questionText: "Left ear .500",
        medicalTypes
    },
    {
        id: questionIds.AudiometryRightEar0_500,
        questionText: "Right ear .500",
        medicalTypes
    },
    {
        id: questionIds.AudiometryLeftEar0_750,
        questionText: "Left ear .750",
        medicalTypes
    },
    {
        id: questionIds.AudiometryRightEar0_750,
        questionText: "Right ear .750",
        medicalTypes
    },
    {
        id: questionIds.AudiometryLeftEar1_0,
        questionText: "Left ear 1.0",
        medicalTypes
    },
    {
        id: questionIds.AudiometryRightEar1_0,
        questionText: "Right ear 1.0",
        medicalTypes
    },
    {
        id: questionIds.AudiometryLeftEar1_5,
        questionText: "Left ear 1.5",
        medicalTypes
    },
    {
        id: questionIds.AudiometryRightEar1_5,
        questionText: "Right ear 1.5",
        medicalTypes
    },
    {
        id: questionIds.AudiometryLeftEar2_0,
        questionText: "Left ear 2.0",
        medicalTypes
    },
    {
        id: questionIds.AudiometryRightEar2_0,
        questionText: "Right ear 2.0",
        medicalTypes
    },
    {
        id: questionIds.AudiometryLeftEar3_0,
        questionText: "Left ear 3.0",
        medicalTypes
    },
    {
        id: questionIds.AudiometryRightEar3_0,
        questionText: "Right ear 3.0",
        medicalTypes
    },
    {
        id: questionIds.AudiometryLeftEar4_0,
        questionText: "Left ear 4.0",
        medicalTypes
    },
    {
        id: questionIds.AudiometryRightEar4_0,
        questionText: "Right ear 4.0",
        medicalTypes
    },
    {
        id: questionIds.AudiometryLeftEar6_0,
        questionText: "Left ear 6.0",
        medicalTypes
    },
    {
        id: questionIds.AudiometryRightEar6_0,
        questionText: "Right ear 6.0",
        medicalTypes
    },
    {
        id: questionIds.AudiometryLeftEar8_0,
        questionText: "Left ear 8.0",
        medicalTypes
    },
    {
        id: questionIds.AudiometryRightEar8_0,
        questionText: "Right ear 8.0",
        medicalTypes
    },
    {
        id: questionIds.AudiometryLeftEarFrequency,
        questionText: "Left ear frequency: sum of decibel (db) loss in left ear",
        medicalTypes
    },
    {
        id: questionIds.AudiometryRightEarFrequency,
        questionText: "Right ear frequency: sum of decibel (db) loss in right ear",
        medicalTypes
    },
    {
        id: questionIds.AudiometryUnilateralDifference,
        questionText: "Unilateral difference in db",
        medicalTypes
    },
    {
        id: questionIds.AudiometryUnilateralAction,
        questionText: "Action?",
        medicalTypes
    },
    {
        id: questionIds.AudiometryHearingCategory,
        questionText: "Hearing Category",
        medicalTypes
    },
    {
        id: questionIds.AudiometryResultsExplained,
        questionText: "Results explained to employee with implications for future impact on hearing?",
        medicalTypes
    },
    {
        id: questionIds.AudiometryPpeAvailableForInspection,
        questionText: "PPE available for inspection?",
        medicalTypes
    },
    {
        id: questionIds.AudiometryPpeComfortableAndFitForPurpose,
        questionText: "PPE comfortable and fit for purpose?",
        medicalTypes
    },
    {
        id: questionIds.AudiometryPpeComfortableAndFitForPurposeComments,
        questionText: "Advice Given",
        medicalTypes
    },
    {
        id: questionIds.AudiometryReferralRequired,
        questionText: "Does employee require referral?",
        medicalTypes
    },
    {
        id: questionIds.AudiometryAdviceRecommendationLetterForGpSupplied,
        questionText: "Advice/recommendation letter for GP supplied to employee today?",
        medicalTypes
    },
    {
        id: questionIds.AudiometryReviewDateRecommended,
        questionText: "Review date recommended?",
        medicalTypes
    },
    {
        id: questionIds.AudiometryReviewDateRecommendedComments,
        questionText: "Recommended Review Date",
        medicalTypes
    }
];
